import { createSlice } from "@reduxjs/toolkit";
import AdminActions from "../Actions/AdminActions";
import { toast } from "react-toastify";
import { changePassword, editProfile } from "../Actions/auth";
import { addAdmin, addChatBot, addFaq, addPrompt, editAdmin } from "../Actions/event";

const initialState = {
    loading: false,
    administrators: {},
    faqs: {},
    resources: {},
    transactions: {},
    clientEventsList: [],
    visibleRange: null,
    newUserLists: []
}

const adminActionSlice = createSlice({
    name: "adminActionSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(AdminActions.createAdministrator.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(AdminActions.createAdministrator.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(AdminActions.createAdministrator.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(addAdmin.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(addAdmin.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(addAdmin.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(editAdmin.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(editAdmin.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(editAdmin.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(addPrompt.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(addPrompt.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(addPrompt.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(addFaq.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(addFaq.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(addFaq.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(addChatBot.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(addChatBot.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(addChatBot.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(AdminActions.getAdministrator.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                state.administrators = payload.data
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(AdminActions.getAdministrator.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(AdminActions.getAdministrator.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(AdminActions.createFaq.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(AdminActions.createFaq.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(AdminActions.createFaq.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(AdminActions.getFaq.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                state.faqs = payload.data
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(AdminActions.getFaq.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(AdminActions.getFaq.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(AdminActions.createResource.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(AdminActions.createResource.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(AdminActions.createResource.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(AdminActions.getResource.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                state.resources = payload.data
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(AdminActions.getResource.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(AdminActions.getResource.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(AdminActions.deleteResource.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(AdminActions.deleteResource.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(AdminActions.deleteResource.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(changePassword.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(changePassword.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(changePassword.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(editProfile.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(editProfile.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(editProfile.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================


        builder.addCase(AdminActions.getTransactions.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.loading = false
                state.transactions = payload.data
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(AdminActions.getTransactions.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(AdminActions.getTransactions.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })
        // ========================================================================


        builder.addCase(AdminActions.deleteReport.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(AdminActions.deleteReport.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(AdminActions.deleteReport.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })

        // ========================================================================

        builder.addCase(AdminActions.createNotification.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(AdminActions.createNotification.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(AdminActions.createNotification.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })
        // ========================================================================

        builder.addCase(AdminActions.deleteNotification.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                toast.success(payload?.message)
            } else {
                toast.error(payload?.message)
                state.loading = false
            }
        })
        builder.addCase(AdminActions.deleteNotification.pending, (state, { payload }) => {
            state.loading = true
        })
        builder.addCase(AdminActions.deleteNotification.rejected, (state, { payload }) => {
            state.loading = false
            toast.error(payload?.message || "Something went wrong")
        })
    },
});

export default adminActionSlice.reducer;